<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
        <sm-form  [form]="form">
        </sm-form>
        <p-button icon="fas fa-circle-down" label="Holen" (onClick)="get()"></p-button>
    </p-panel>
    <div class="flex-item-fill flex-col">
        <sm-toolbar>
            <p-radioButton label="Alle" name="all" value="all" [(ngModel)]="source" inputId="sourceAll" (ngModelChange)="updateTable()"></p-radioButton>
            <p-radioButton class="ml-3" label="Nur mit Fundstelle in enaio" name="enaio" value="enaio" [(ngModel)]="source" inputId="sourceEnaio" (ngModelChange)="updateTable()"></p-radioButton>
            <p-radioButton class="ml-3" label="Nur mit Fundstelle in datev" name="datev" value="datev" [(ngModel)]="source" inputId="sourceDatev" (ngModelChange)="updateTable()"></p-radioButton>
        </sm-toolbar>
        <sm-table2 *ngIf="table != null" class="flex-item-fill height100p" [data]="table" (onCellClicked)="clickCell($event)"></sm-table2>
    </div>
</div>
